import { useState, type FormEvent } from "react";

const FORM_URL = "https://readdy.ai/api/form/dae17eptto0ceqqngnh0";

const principles = [
  { icon: "ri-focus-3-line", title: "先求证，再发布", desc: "涉及人物与事实的内容，尽量以官方回应与正规信源为准，不给未证信息贴'实锤'标签。" },
  { icon: "ri-time-line", title: "给时间线，不赶热度", desc: "单条爆料可能是拼图一角，我们愿意等一等，把完整脉络整理清楚再讲给你听。" },
  { icon: "ri-contrast-2-line", title: "理性围观，克制表达", desc: "少一点情绪站队，多一点换位共情。我们倡导温和、清醒的围观氛围。" },
];

export default function AboutSubscribe() {
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [formError, setFormError] = useState("");
  const [email, setEmail] = useState("");

  const onSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);

    const honeypot = String(fd.get("email_alt") ?? "").trim();
    if (honeypot) {
      setStatus("success");
      form.reset();
      setEmail("");
      return;
    }
    fd.delete("email_alt");

    setStatus("loading");
    setFormError("");
    try {
      const res = await fetch(FORM_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(fd as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed: { code?: string; message?: string; meta?: { message?: string; detail?: string } } | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.meta?.detail || parsed?.message || responseText || "";
      const success = res.ok && parsed?.code === "OK";

      if (success && !serverMsg.toLowerCase().includes("spam")) {
        setStatus("success");
        form.reset();
        setEmail("");
      } else {
        setStatus("error");
        setFormError(serverMsg || "订阅失败，请稍后重试。");
      }
    } catch {
      setStatus("error");
      setFormError("网络异常，订阅失败，请稍后重试。");
    }
  };

  return (
    <section id="about" className="scroll-mt-20 bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid items-center gap-10 lg:grid-cols-[1fr_1fr]">
          <div>
            <p className="text-sm font-semibold tracking-widest text-primary-500 uppercase">关于看吃瓜</p>
            <h2 className="mt-2 font-fun text-3xl text-foreground-950 md:text-4xl">把散落全网的热点，拼成一张清楚的地图</h2>
            <p className="mt-4 leading-7 text-foreground-700">
              看吃瓜是一个面向全网热点与热议事件的资讯围观平台。我们不生产猎奇，只做两件事：帮你把事件的来龙去脉捋清楚，
              以及帮你节省在信息洪流里来回翻找的时间。无论是爆款大瓜还是身边的小话题，都能在这里快速吃明白。
            </p>

            <div className="mt-8 grid gap-4 sm:grid-cols-3">
              {principles.map((p) => (
                <div key={p.title} className="rounded-2xl border border-background-200 bg-background-100 p-5">
                  <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary-100 text-primary-600">
                    <i className={`${p.icon} text-lg`} aria-hidden="true"></i>
                  </span>
                  <h3 className="mt-3 font-bold text-foreground-900">{p.title}</h3>
                  <p className="mt-1.5 text-sm leading-6 text-foreground-600">{p.desc}</p>
                </div>
              ))}
            </div>

            <div className="mt-6 flex flex-wrap items-center gap-4 rounded-2xl bg-secondary-100 p-5 text-sm text-secondary-900">
              <span className="inline-flex items-center gap-2 font-semibold">
                <i className="ri-mail-send-line text-lg" aria-hidden="true"></i>意见反馈 / 投稿爆料
              </span>
              <a href="mailto:hello@kanchigua.example" className="font-bold underline underline-offset-4">
                hello@kanchigua.example
              </a>
              <span className="text-secondary-900/70">工作日 48 小时内回复</span>
            </div>
          </div>

          <div id="subscribe" className="scroll-mt-24">
            <div className="overflow-hidden rounded-3xl border border-background-200 bg-gradient-to-br from-primary-600 to-primary-500 p-8 text-background-50 md:p-10">
              <span className="inline-flex items-center gap-2 rounded-full bg-background-50/15 px-4 py-1.5 text-sm font-semibold">
                <i className="ri-notification-3-line text-accent-200" aria-hidden="true"></i>吃瓜快讯订阅
              </span>
              <h3 className="mt-4 font-fun text-3xl">别错过下一颗大瓜</h3>
              <p className="mt-2 max-w-md text-background-50/85">
                留下邮箱，新瓜上架、专题更新与深度复盘发布时第一时间推送给你。安心围观，不用天天蹲热搜。
              </p>

              {status === "success" ? (
                <div className="mt-6 flex items-center gap-3 rounded-2xl bg-background-50/15 p-5 backdrop-blur-sm">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-accent-300 text-primary-950">
                    <i className="ri-check-line text-xl" aria-hidden="true"></i>
                  </span>
                  <p className="font-semibold">订阅成功，欢迎加入吃瓜前排！新瓜提醒马上为你安排。</p>
                </div>
              ) : (
                <form onSubmit={onSubmit} className="mt-6" data-readdy-form="dae17eptto0ceqqngnh0">
                  <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
                    <label className="relative block flex-1">
                      <i className="ri-mail-line absolute left-4 top-1/2 -translate-y-1/2 text-lg text-background-50/60" aria-hidden="true"></i>
                      <input
                        type="email"
                        name="email"
                        required
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="输入常用邮箱"
                        className="w-full rounded-full border border-background-50/30 bg-background-50/10 py-3 pl-11 pr-4 text-background-50 outline-none placeholder:text-background-50/50 focus:border-accent-300 focus:bg-background-50/15"
                      />
                    </label>
                    <button
                      type="submit"
                      disabled={status === "loading"}
                      className="whitespace-nowrap rounded-full bg-accent-400 px-6 py-3 font-bold text-primary-950 transition-colors hover:bg-accent-300 disabled:cursor-not-allowed disabled:opacity-60"
                    >
                      {status === "loading" ? "订阅中…" : "立即订阅"}
                    </button>
                  </div>

                  <input
                    type="text"
                    name="email_alt"
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                    readOnly
                    className="captcha-trap"
                  />

                  {status === "error" && formError && (
                    <p className="mt-3 text-sm font-medium text-accent-200">{formError}</p>
                  )}
                  <p className="mt-3 text-xs text-background-50/60">
                    订阅即代表同意接收看吃瓜的推送邮件，可随时退订。我们不会向第三方泄露你的邮箱。
                  </p>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}